export const STRING = 'string';
export const DATE = 'date';
export const EMAIL = 'email';
export const NUMBER = 'number';
export const PHONE = 'tel';
export const TIME = 'time';
export const URL = 'url';
